var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiverseBw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2167 28.95C45.1001 28.9333 44.9834 28.9333 44.8667 28.95C42.2834 28.8666 40.2334 26.75 40.2334 24.15C40.2334 21.5 42.3834 19.3333 45.0501 19.3333C47.7001 19.3333 49.8667 21.4833 49.8667 24.15C49.8501 26.75 47.8001 28.8666 45.2167 28.95Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6498 40.5C48.7832 41.75 46.1665 42.2167 43.7498 41.9C44.3832 40.5333 44.7165 39.0167 44.7332 37.4167C44.7332 35.75 44.3665 34.1667 43.6665 32.7833C46.1332 32.45 48.7498 32.9167 50.6332 34.1667C53.2665 35.9 53.2665 38.75 50.6498 40.5Z",
    fill: "#777777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7334 28.95C26.8501 28.9333 26.9668 28.9333 27.0834 28.95C29.6668 28.8666 31.7168 26.75 31.7168 24.15C31.7168 21.4833 29.5668 19.3333 26.9001 19.3333C24.2501 19.3333 22.1001 21.4833 22.1001 24.15C22.1001 26.75 24.1501 28.8666 26.7334 28.95Z",
    fill: "#777777"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9169 37.4167C26.9169 39.0333 27.2669 40.5667 27.9002 41.95C25.5502 42.2 23.1002 41.7 21.3002 40.5167C18.6669 38.7667 18.6669 35.9167 21.3002 34.1667C23.0835 32.9667 25.6002 32.4833 27.9669 32.75C27.2835 34.15 26.9169 35.7333 26.9169 37.4167Z",
    fill: "#777777"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2 42.45C36.0667 42.4333 35.9167 42.4333 35.7667 42.45C32.7 42.35 30.25 39.8333 30.25 36.7333C30.2667 33.5667 32.8167 31 36 31C39.1667 31 41.7333 33.5667 41.7333 36.7333C41.7167 39.8333 39.2833 42.35 36.2 42.45Z",
    fill: "#777777"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7835 45.9C28.2668 47.5834 28.2668 50.35 30.7835 52.0167C33.6502 53.9334 38.3502 53.9334 41.2168 52.0167C43.7335 50.3334 43.7335 47.5667 41.2168 45.9C38.3668 43.9834 33.6668 43.9834 30.7835 45.9Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiverseBw);
export default __webpack_public_path__ + "static/media/diverse-bw.fa96e700cafd45296642ac4bcfc11b39.svg";
export { ForwardRef as ReactComponent };